var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Settings"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9446 0.833984H2.05572C1.3807 0.833984 0.833496 1.38119 0.833496 2.05621V17.9451C0.833496 18.6201 1.3807 19.1673 2.05572 19.1673H17.9446C18.6196 19.1673 19.1668 18.6201 19.1668 17.9451V2.05621C19.1668 1.38119 18.6196 0.833984 17.9446 0.833984Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.8149 13.0566H15.5001",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.50049 13.0566H6.74123",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8148 13.0566C10.8148 13.4595 10.6953 13.8533 10.4715 14.1883C10.2477 14.5233 9.92952 14.7844 9.5573 14.9385C9.18508 15.0927 8.7755 15.1331 8.38035 15.0545C7.98521 14.9759 7.62224 14.7819 7.33736 14.497C7.05247 14.2121 6.85846 13.8491 6.77986 13.454C6.70127 13.0588 6.74161 12.6492 6.89578 12.277C7.04996 11.9048 7.31105 11.5867 7.64604 11.3628C7.98103 11.139 8.37487 11.0195 8.77776 11.0195C9.31802 11.0195 9.83615 11.2341 10.2182 11.6162C10.6002 11.9982 10.8148 12.5163 10.8148 13.0566V13.0566Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.6301 6.94531H4.50049",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7035 6.94524C15.7035 6.54235 15.584 6.14851 15.3602 5.81352C15.1363 5.47854 14.8182 5.21744 14.446 5.06326C14.0738 4.90909 13.6642 4.86875 13.269 4.94735C12.8739 5.02594 12.5109 5.21995 12.226 5.50484C11.9411 5.78972 11.7471 6.15269 11.6685 6.54784C11.5899 6.94298 11.6303 7.35256 11.7845 7.72478C11.9386 8.097 12.1997 8.41514 12.5347 8.63898C12.8697 8.86281 13.2635 8.98228 13.6664 8.98228C14.2067 8.98228 14.7248 8.76766 15.1068 8.38564C15.4889 8.00363 15.7035 7.4855 15.7035 6.94524Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.9bbc7aa2.svg";
export { ForwardRef as ReactComponent };